import { SurveyTemplate } from 'common/lib/entity/framework/SurveyTemplate';
import * as ROUTES from 'src/api/routes';
import { FilterQueryParams } from 'src/utils/types';
import request from './utils';

export async function getSurveyTemplates() {
    const response = await request({ ...ROUTES.ADMIN_GET_SURVEY_TEMPLATES });

    return { result: response.data || [], count: response.data.length || 0 };
}